// @flow
import { connect } from 'react-redux';
import vehicleActions from '../../../actions/vehicleActions';
import CarForm from '../CarForm';
import type { Props } from '../CarForm';

const mapDispatchToProps = {
    createCar: vehicleActions.createVehicle
};

export default connect<Props, *, _, _, _, _>(null, mapDispatchToProps)(CarForm);